
export class AloSecurityItem {       

    public enable : boolean
    public visible : boolean


    constructor({enable = false,visible=false} = {}) {        
        this.enable = enable
        this.visible = visible
    }
    
}
